import { render, staticRenderFns } from "./registrationSurface.vue?vue&type=template&id=ff31d98e&scoped=true"
import script from "./registrationSurface.vue?vue&type=script&lang=js"
export * from "./registrationSurface.vue?vue&type=script&lang=js"
import style0 from "./registrationSurface.vue?vue&type=style&index=0&id=ff31d98e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff31d98e",
  null
  
)

export default component.exports